/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const CIRCLE_CHECK_VIEWBOX = 16;

const CIRCLE_CHECK_ARC_PATH =
  'M14.5249 6.66253C15.1519 9.73962 13.545 12.8368 10.6683 14.0961C7.79154 15.3554 4.42598 14.435 2.59052 11.8869C0.755061 9.3388 0.94809 5.85498 3.05381 3.52527C5.15953 1.19556 8.60618 0.652549 11.3262 2.22197';

const CIRCLE_CHECK_MARK_PATH =
  'M5.99609 7.32873L7.99484 9.32748L14.6573 2.66498';

const iconPropTypes = {
  size: PropTypes.number,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Check with partial circle arc (16×16). Stroke-based success / completion icon.
 * Color via `stroke` / `currentColor` (e.g. `ds-icon--color-success`).
 * Pass `aria-label` when icon conveys meaning without adjacent text.
 */
const CircleCheckIcon = ({
  size = 16,
  stroke = 'currentColor',
  strokeWidth = 1.3325,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${CIRCLE_CHECK_VIEWBOX} ${CIRCLE_CHECK_VIEWBOX}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={['ds-icon', className].filter(Boolean).join(' ')}
    aria-hidden={ariaLabel ? undefined : ariaHidden}
    aria-label={ariaLabel || undefined}
    role={ariaLabel ? 'img' : undefined}
    focusable="false"
    {...props}
  >
    <path
      d={CIRCLE_CHECK_ARC_PATH}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d={CIRCLE_CHECK_MARK_PATH}
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

CircleCheckIcon.propTypes = iconPropTypes;

export { CircleCheckIcon };
export default CircleCheckIcon;
